import getConfig from 'next/config'

import { BloomreachSettings, withBloomreach } from '@grandvisionhq/next'

import { featureToggles } from '../configuration/feature-toggles'
import { INTL_DEFAULTS } from '../configuration/intl'

const { isMultilingualEnabled } = featureToggles

const { publicRuntimeConfig } = getConfig()
const { apiUrl } = publicRuntimeConfig.bloomreach ?? {}

const bloomreachSettings: BloomreachSettings = {
  apiUrl,
}

const settings = {
  bloomreach: bloomreachSettings,
  isMultilingualEnabled,
  defaultLocale: INTL_DEFAULTS.locale,
}

export default withBloomreach(settings)
